
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Ashoklayland() {



    const cardData =
    {
        keyword: 'Ashok Leyland Ac 45 Seater Bus Hire in Pune',
        heading: 'Amruta Travels: Ashok Leyland Ac 45 Seater Bus Hire in Pune',
        headingDescription: 'Amruta Travels offers Ashok Leyland AC 45 Seater Bus Hire in Pune, the ideal choice for large group travel with comfort and reliability. Whether you are organizing a school excursion, corporate event, religious trip, or wedding transportation, our well-maintained Ashok Leyland buses deliver a smooth and luxurious travel experience. With powerful air-conditioning, cushioned seating, ample luggage space, and experienced drivers, we ensure your journey is safe, timely, and comfortable. Backed by competitive pricing and 24/7 booking support, Amruta Travels is your trusted partner for group bus rentals in Pune.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',


  "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Located around 120 km from Pune, Mahabaleshwar is a picturesque hill station in the Western Ghats, known for its cool climate, evergreen forests, and stunning viewpoints such as Arthur’s Seat, Wilson Point (the highest point), and Kate's Point. The region is famous for its strawberry farms, especially during the Strawberry Festival held in spring. Other attractions include Venna Lake for boating, Mapro Garden for strawberry-based treats, and ancient temples like Panchganga and Mahabaleshwar Temple. It's a popular destination for families, honeymooners, and nature enthusiasts seeking a refreshing escape from city life."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range offer a perfect blend of natural beauty and adventure. Lonavala is known for its misty mountains, lush greenery, and monsoon waterfalls like Kune and Bhivpuri. Attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla & Bhaja Caves. Khandala is equally famous for its panoramic valley views and trekking routes. The area is ideal for a weekend drive, with scenic routes and roadside chikki stalls that add to the charm of this quick getaway."
    },
    {
      "title": "Shirdi",
      "description": "About 190 km from Pune, Shirdi is a sacred town revered by followers of Sai Baba. The Sai Baba Samadhi Mandir is the main attraction, drawing millions of devotees every year. Pilgrims can also visit Dwarkamai, Chavadi, and the Sai Heritage Village. The spiritual ambiance, combined with well-maintained infrastructure and religious events, makes Shirdi a prominent destination for those seeking peace, healing, and spiritual growth."
    },
    {
      "title": "Goa",
      "description": "Located nearly 450 km from Pune, Goa is India’s premier beach destination, known for its lively culture, golden beaches, and Portuguese heritage. From North Goa’s party hotspots like Baga, Anjuna, and Calangute to South Goa’s serene stretches like Palolem and Colva, there’s a vibe for every traveler. Apart from beaches, visitors can explore Aguada Fort, Basilica of Bom Jesus, spice plantations, vibrant flea markets, and indulge in thrilling water sports. Goa is also a haven for foodies, offering authentic seafood, Goan curries, and beachside shacks serving refreshing cocktails."
    },
    {
      "title": "Nashik",
      "description": "Around 210 km from Pune, Nashik is a city of immense cultural, historical, and spiritual significance. It is one of the four cities where the Kumbh Mela is held. Attractions include the ancient Kalaram Temple, Muktidham Temple, Pandavleni Caves, and Trimbakeshwar Temple—an important Jyotirlinga. Nashik is also the wine capital of India, home to Sula Vineyards, York Winery, and many tasting tours. The Godavari River adds to its charm, making it a harmonious blend of spirituality and leisure tourism."
    },
    {
      "title": "Alibaug",
      "description": "Situated about 140 km from Pune, Alibaug is a tranquil coastal town offering a perfect mix of beaches, history, and nature. Popular beaches include Nagaon, Alibaug Beach, and Kashid Beach, all great for swimming, sunbathing, and water sports. The iconic Kolaba Fort, accessible during low tide, adds historical value to the destination. You can also explore Korlai Fort, Kanakeshwar Temple, and local seafood cuisine. Ideal for weekend trips, Alibaug also offers ferry services from Mumbai for added convenience."
    },
    {
      "title": "Kolhapur",
      "description": "Roughly 235 km from Pune, Kolhapur is a vibrant city known for its divine Mahalaxmi Temple, which draws pilgrims throughout the year. The city is equally famous for its spicy cuisine, Kolhapuri chappals, and traditional arts. Attractions include Rankala Lake for evening strolls, Panhala Fort offering panoramic views, and the New Palace Museum showcasing royal heritage. With its rich cultural identity and warm hospitality, Kolhapur is ideal for heritage and culinary tourism."
    },
    {
      "title": "Lavasa",
      "description": "Just 60 km from Pune, Lavasa is an Italian-inspired planned city nestled in the Sahyadri hills. It features beautiful waterfronts, European-style architecture, and a peaceful atmosphere perfect for a quick weekend escape. Activities include kayaking, zip-lining, and lakeside cycling. With cozy resorts, conference centers, and nature trails, Lavasa attracts both families and corporate travelers. The weather remains pleasant most of the year, enhancing its appeal as a rejuvenating destination close to Pune."
    },
    {
      "title": "Satara & Kaas Plateau",
      "description": "About 120 km from Pune, Satara serves as the base for exploring the Kaas Plateau—popularly known as the 'Valley of Flowers' of Maharashtra. The plateau, a UNESCO World Natural Heritage site, bursts into a riot of colors with over 850 species of wildflowers during the monsoon season. Satara is also known for Ajinkyatara Fort, Thoseghar Waterfalls, and Sajjangad Fort. The natural beauty and biodiversity make this region a paradise for trekkers, botanists, and photographers."
    },
    {
      "title": "Aurangabad",
      "description": "Situated 235 km from Pune, Aurangabad is a historical treasure trove, offering insights into ancient art, architecture, and culture. The city is home to the world-famous Ajanta and Ellora Caves, adorned with exquisite carvings and paintings dating back to 2nd century BCE. Other attractions include Bibi Ka Maqbara (a replica of the Taj Mahal), Daulatabad Fort, and Aurangabad Caves. The city is also a gateway to Grishneshwar Jyotirlinga and Paithani saree shopping, making it a must-visit for heritage lovers."
    }
  ],

   "services": [
    {
      "name": "Ashok Leyland 45 Seater Bus on Rent Pune",
      "description": "Amruta Travels offers Ashok Leyland 45 Seater AC buses for rent in Pune, ideal for large groups traveling for corporate events, weddings, school trips, or outstation tours. These buses come equipped with AC, comfortable pushback seats, and ample luggage space, providing a smooth and enjoyable travel experience for every passenger."
    },
    {
      "name": "AC 45 Seater Bus Hire in Pune",
      "description": "Our AC 45 Seater buses in Pune are perfect for group travel, whether it’s for a corporate outing, school excursion, or family trip. With modern amenities like AC, spacious interiors, and comfortable seating, these buses ensure a pleasant and hassle-free journey across Pune or to nearby destinations."
    },
    {
      "name": "Corporate Event Ashok Leyland Bus Pune",
      "description": "Make your corporate event transportation hassle-free with our Ashok Leyland 45 Seater buses in Pune. These buses are perfect for transporting employees or clients to events, seminars, or corporate meetings, ensuring comfort, punctuality, and safety throughout the trip."
    },
    {
      "name": "Wedding Bus Rental Ashok Leyland Pune",
      "description": "Travel in comfort and style with our Ashok Leyland 45 Seater buses for weddings in Pune. Whether it’s transporting guests to the wedding venue or providing transportation for an outstation wedding, our buses are equipped with AC, luxury seating, and a smooth ride to make your wedding journey special."
    },
    {
      "name": "45 Seater Bus Rental Pimpri Chinchwad",
      "description": "Looking for a spacious and comfortable bus for your group trip from Pimpri Chinchwad? Amruta Travels provides Ashok Leyland 45 Seater buses for rent in Pimpri Chinchwad, perfect for school picnics, corporate events, or family outings. Our buses offer comfort, air conditioning, and reliability."
    },
    {
      "name": "45 Seater Bus Booking for School Trips",
      "description": "Book an Ashok Leyland 45 Seater AC bus for your school trips in Pune. Our buses are equipped with safety features, ample space for students and teachers, and air conditioning, making school outings both enjoyable and safe."
    },
    {
      "name": "45 Seater AC Bus for Marriage Functions",
      "description": "Our 45 Seater AC buses are ideal for transporting wedding guests in Pune. With comfortable seating, ample legroom, and air conditioning, your guests will travel in style and comfort, ensuring timely arrival for your wedding events."
    },
    {
      "name": "45 Seater Bus Hire for Corporate Travel",
      "description": "Rent an Ashok Leyland 45 Seater bus for your corporate travel needs in Pune. Whether it’s for team outings, client visits, or corporate meetings, our buses provide a comfortable and professional travel experience, complete with air conditioning and onboard amenities."
    },
    {
      "name": "Ashok Leyland Bus Hire for Religious Tours",
      "description": "Plan your religious trips with Amruta Travels' Ashok Leyland 45 Seater buses. Ideal for group pilgrimages to religious sites like Shirdi, Pandharpur, or Alandi, our buses provide a safe, comfortable, and hassle-free journey with AC and professional drivers."
    },
    {
      "name": "Ashok Leyland 45 Seater for Outstation",
      "description": "Rent an Ashok Leyland 45 Seater bus for your next outstation trip from Pune. Whether it’s a visit to Mahabaleshwar, Goa, or other popular destinations, our buses are perfect for long-distance journeys, offering comfort, ample space, and safety features for your group."
    },
    {
      "name": "Ashok Leyland AC Bus in Hadapsar",
      "description": "Looking for a bus rental service in Hadapsar? Amruta Travels offers Ashok Leyland 45 Seater AC buses for rent, perfect for both short and long-distance trips. Experience comfortable travel for school picnics, family events, and corporate functions with our well-maintained fleet."
    },
    {
      "name": "Bus Hire from Pune to Shirdi",
      "description": "Take a spiritual journey to Shirdi with our Ashok Leyland 45 Seater buses. Ideal for group pilgrimages, our buses provide comfortable seating, air conditioning, and professional drivers to ensure a safe and peaceful experience on your way to the Shirdi temple."
    },
    {
      "name": "Pune to Kolhapur Bus on Rent",
      "description": "Book an Ashok Leyland 45 Seater bus for your group travel from Pune to Kolhapur. Whether it’s for a family trip, corporate outing, or pilgrimage, our buses are equipped with AC, comfortable seating, and all the necessary amenities to make your journey smooth and enjoyable."
    },
    {
      "name": "Long Distance Ashok Leyland Bus Rental",
      "description": "For long-distance travel, trust Amruta Travels’ Ashok Leyland 45 Seater buses. Perfect for cross-state trips or long tours, our buses come with air conditioning, pushback seats, and a comfortable environment to ensure you reach your destination refreshed."
    },
    {
      "name": "Luxury AC Ashok Leyland Coach Hire Pune",
      "description": "For the ultimate comfort in group travel, opt for our Luxury AC Ashok Leyland coaches. Equipped with premium features like plush seating, ample legroom, and modern amenities, these buses are perfect for high-end corporate events, weddings, or luxury tours in Pune and beyond."
    }
  ],
  "tableData": [
    ["Ashok Leyland 45 Seater Bus on Rent Pune", "AC 45 Seater Bus Hire in Pune"],
    ["Corporate Event Ashok Leyland Bus Pune", "Wedding Bus Rental Ashok Leyland Pune"],
    ["45 Seater Bus Rental Pimpri Chinchwad", "45 Seater Bus Booking for School Trips"],
    ["45 Seater AC Bus for Marriage Functions", "45 Seater Bus Hire for Corporate Travel"],
    ["Ashok Leyland Bus Hire for Religious Tours", "Ashok Leyland 45 Seater for Outstation"],
    ["Ashok Leyland AC Bus in Hadapsar", "Bus Hire from Pune to Shirdi"],
    ["Pune to Kolhapur Bus on Rent", "Long Distance Ashok Leyland Bus Rental"],
    ["Luxury AC Ashok Leyland Coach Hire Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Comfortable Ashok Leyland AC 45 Seater Bus on Hire in Pune",
    "WhyChoosedescription": "Amruta Travels offers premium Ashok Leyland AC 45 Seater buses for hire in Pune, designed for large group travel. Whether it’s a corporate event, family trip, or a wedding, our Ashok Leyland buses offer an excellent travel solution for groups looking for comfort and reliability."
  },
  {
    "WhyChooseheading": "Spacious and Air-Conditioned Travel for Large Groups",
    "WhyChoosedescription": "Our Ashok Leyland AC 45 Seater buses are fully air-conditioned, with plenty of space to relax. With cushioned seats, ample legroom, and climate control, every passenger can enjoy a comfortable journey, no matter the distance."
  },
  {
    "WhyChooseheading": "Modern Features and Convenient Amenities",
    "WhyChoosedescription": "The buses are equipped with modern features such as adjustable seats, wide windows for scenic views, overhead storage, and a clean interior, providing all the necessary comforts for a pleasant travel experience."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "At Amruta Travels, we offer affordable pricing for Ashok Leyland AC 45 Seater bus rentals with no hidden fees. The cost includes all essentials such as fuel, tolls, driver charges, and taxes, so you can easily plan your travel budget without any surprises."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers for Safe Travel",
    "WhyChoosedescription": "Our drivers are well-trained, licensed, and knowledgeable about Pune and outstation routes. They ensure a safe and timely journey, providing excellent service and ensuring the comfort of all passengers."
  },
  {
    "WhyChooseheading": "Perfect for Group Outings, Corporate Travel, and Weddings",
    "WhyChoosedescription": "The 45 Seater Ashok Leyland bus is the ideal choice for large group events such as corporate outings, family reunions, weddings, or school tours. It combines large capacity with comfort, ensuring your group travels together without any hassle."
  },
  {
    "WhyChooseheading": "Well-Maintained Fleet for a Smooth Experience",
    "WhyChoosedescription": "We take pride in maintaining our Ashok Leyland buses to the highest standards. Each bus undergoes regular checks and cleaning to ensure a smooth, trouble-free journey for every passenger."
  },
  {
    "WhyChooseheading": "Convenient Booking and 24/7 Customer Support",
    "WhyChoosedescription": "Booking your Ashok Leyland AC 45 Seater bus with Amruta Travels is easy. You can make reservations online, over the phone, or in person at our office. Our customer service team is available 24/7 to assist with booking, queries, or any special requests."
  }
]
















    }

const faqData = [
  {
    question: 'Can I rent an Ashok Leyland AC 45-seater bus in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers Ashok Leyland AC 45-seater buses for rent in Pune. These buses are perfect for large groups traveling for corporate events, family outings, school trips, and long-distance travel.',
  },
  {
    question: 'What amenities are available in the Ashok Leyland AC 45-seater bus?',
    answer: 'Our Ashok Leyland AC 45-seater buses are equipped with comfortable plush seats, air conditioning, modern entertainment systems, ample luggage space, and a clean and sanitized interior to ensure a comfortable journey.',
  },
  {
    question: 'Is the Ashok Leyland AC 45-seater bus available for both local and outstation travel?',
    answer: 'Yes, the Ashok Leyland AC 45-seater bus is available for both local travel in Pune as well as outstation trips to popular destinations like Mumbai, Lonavala, Mahabaleshwar, Shirdi, and more.',
  },
  {
    question: 'Is a driver included in the Ashok Leyland bus rental?',
    answer: 'Yes, all Ashok Leyland bus rentals from Amruta Travels come with a professional and licensed driver who ensures the safety, comfort, and timely arrival of all passengers.',
  },
  {
    question: 'How much does it cost to rent an Ashok Leyland AC 45-seater bus in Pune?',
    answer: 'Rental charges for the Ashok Leyland AC 45-seater bus vary based on factors like distance, trip duration, and services. Typically, rates start from ₹70 per km. Contact us for an exact quote tailored to your needs.',
  },
  {
    question: 'Is the Ashok Leyland AC 45-seater bus comfortable for long journeys?',
    answer: 'Yes, the Ashok Leyland AC 45-seater bus is designed for long journeys, offering spacious seating, air conditioning, and plenty of legroom, making it a great choice for extended travel.',
  },
  {
    question: 'Are the Ashok Leyland buses well-maintained and sanitized?',
    answer: 'Definitely. All our Ashok Leyland buses, including the 45-seater models, are regularly serviced, thoroughly cleaned, and sanitized before each trip to ensure maximum hygiene and safety.',
  },
  {
    question: 'How do I book an Ashok Leyland AC 45-seater bus in Pune?',
    answer: 'Booking an Ashok Leyland AC 45-seater bus is easy! You can either book online through our website or contact our customer support team. We offer hassle-free booking and competitive pricing.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sanjay Desai',
    role: 'Business Owner, Pune',
    text: 'We hired an Ashok Leyland AC 45-seater bus from Amruta Travels for a corporate event. The bus was comfortable, spacious, and the service was top-notch. It made our event even more enjoyable!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Anita Suresh',
    role: 'Event Planner',
    text: 'I booked an Ashok Leyland AC 45-seater bus for a destination wedding. The bus was well-maintained and provided a comfortable ride for all our guests. Highly recommend Amruta Travels for group transportation.',
    rating: 5,
  },
];
























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ashok Leyland AC 45 Seater Bus Hire in Pune",
  "image": "https://bushireinpune.com/assets/images/ashok-leyland-45-seater-bus.jpg",
  "description": "Book an Ashok Leyland AC 45 Seater Bus in Pune for corporate events, school trips, weddings, and long-distance travel to Shirdi, Kolhapur, or religious tours. Amruta Travels provides luxury Ashok Leyland coach rentals with air-conditioning, spacious seating, and expert drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2400"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6300",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/ashok-leyland-ac-45-seater-bus-hire-pune"
  }
};






    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Ashok Leyland AC 45 Seater Bus Hire in Pune | Wedding & Corporate Bus Rental</title>
  <meta 
    name="description" 
    content="Hire an Ashok Leyland AC 45 Seater Bus in Pune for school trips, marriage functions, corporate events, and religious tours. Outstation travel to Kolhapur, Shirdi & more with Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/88.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Ashoklayland;